import { z } from 'zod';
import { EmailSchema } from './email.js';
import { PasswordSchema } from './password.js';
export const LoginInput = z.object({
    email: EmailSchema,
    password: z.string().min(1, 'Password required'),
    twoFactorCode: z.string().regex(/^\d{6}$/).optional(),
});
export const RegisterInput = z.object({
    email: EmailSchema,
    password: PasswordSchema,
    recaptchaToken: z.string().min(1),
});
export const ResetPasswordInput = z.object({
    token: z.string().min(1),
    newPassword: PasswordSchema,
});
export const Verify2FAInput = z.object({
    sessionToken: z.string().min(1),
    code: z.string().regex(/^\d{6}$/, '2FA code must be 6 digits'),
});
//# sourceMappingURL=auth.js.map